module.exports = __webpack_public_path__ + "media/images/flags/64/Niue-f6baba439e4e914f7cce265854db6213.png";